module.exports = __webpack_public_path__ + "img/titulo-base-de-datos.7db06d48.png";